const SITUATIONS = [
  {
    icon: 'ri-door-open-line',
    title: 'Нет навеса над крыльцом',
    desc: 'Козырёк защитит входную дверь и&nbsp;крыльцо от&nbsp;дождя и&nbsp;снега. Больше не&nbsp;нужно открывать дверь под&nbsp;ливнем.',
  },
  {
    icon: 'ri-home-2-line',
    title: 'Нужен декор для фасада',
    desc: 'Кованый козырёк — это украшение дома. Элементы художественной ковки придают индивидуальность и&nbsp;статус фасаду.',
  },
  {
    icon: 'ri-snowy-line',
    title: 'Защита от снега и наледи',
    desc: 'Прочная конструкция выдерживает снеговую нагрузку. Снег не&nbsp;скапливается у&nbsp;порога, крыльцо всегда чистое.',
  },
  {
    icon: 'ri-store-2-line',
    title: 'Козырёк для магазина или офиса',
    desc: 'Изготовим навес над входом в&nbsp;коммерческое помещение. Стильно, надёжно, с&nbsp;учётом городской архитектуры.',
  },
];

export default function UseCasesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6" style={{ maxWidth: '1400px' }}>
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Подойдёт, если вам нужно
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Четыре ситуации, в которых козырёк решает задачу с&nbsp;защитой входа и&nbsp;украшением фасада
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {SITUATIONS.map((item, idx) => (
            <div
              key={item.title}
              className="group bg-background-100 border border-background-200/70 rounded-lg p-5 md:p-6 transition-all duration-400 hover:border-primary-200/50 animate-fade-in-up"
              style={{ animationDelay: `${idx * 0.1}s` }}
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-400">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed" dangerouslySetInnerHTML={{ __html: item.desc }}></p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}